import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function BookOpenIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M21 4.688h-6a3.56 3.56 0 0 0-3 1.645 3.56 3.56 0 0 0-3-1.645H3A1.31 1.31 0 0 0 1.688 6v12A1.31 1.31 0 0 0 3 19.312h6a2.44 2.44 0 0 1 2.437 2.437.563.563 0 1 0 1.125 0 2.44 2.44 0 0 1 2.437-2.437h6A1.31 1.31 0 0 0 22.311 18V6a1.31 1.31 0 0 0-1.312-1.312m-12 13.5H3A.187.187 0 0 1 2.813 18V6A.187.187 0 0 1 3 5.813h6a2.44 2.44 0 0 1 2.437 2.437v10.904A3.55 3.55 0 0 0 9 18.188M21.187 18a.187.187 0 0 1-.187.187h-6a3.55 3.55 0 0 0-2.437.968V8.25A2.44 2.44 0 0 1 15 5.812h6a.187.187 0 0 1 .187.188zm-1.875-9a.56.56 0 0 1-.563.563H15a.563.563 0 1 1 0-1.125h3.75a.56.56 0 0 1 .562.563m0 3a.56.56 0 0 1-.563.563H15a.563.563 0 1 1 0-1.125h3.75a.56.56 0 0 1 .562.561m0 3a.56.56 0 0 1-.563.563H15a.563.563 0 1 1 0-1.125h3.75a.56.56 0 0 1 .562.563"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
